import { Injectable } from "@angular/core";
import { MCHttpWrapperService, MCResponse } from "@maslul/common-services";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MIHttpService {
    controllerUrl: string = 'MyImport';
    miController: string = 'api/MIUnionRequest/';

    constructor(private httpWrapperService: MCHttpWrapperService) {

    }



    GetApprovalTabs(approvalTypeIds: Array<number> | null = null, approvalMainTypeIds: Array<number> | null = null): Observable<MCResponse> {//??

        let url = "";

        approvalTypeIds?.forEach(approvalTypeId => {
            url += "approvalTypesId=" + approvalTypeId + "&";
        });
        approvalMainTypeIds?.forEach(pprovalMainTypeId => {
            url += "mainTypesId=" + pprovalMainTypeId + "&";
        });
        url = this.miController + this.controllerUrl + '/approval-tabs?' + url.substring(0, url.length - 1);
        return this.httpWrapperService.getData(url)
    }

    send(requestData: any): Observable<MCResponse> {
        const url = this.miController + this.controllerUrl + '/send'
        const sendRequest: Observable<MCResponse> = this.httpWrapperService.sendData(url, requestData) as Observable<MCResponse>;
        return sendRequest;
    }

}